export function isActionChildEvent(id) {
    return (event) => event.action !== undefined && event.action.id !== undefined && event.action.id.includes(id);
}
//# sourceMappingURL=isActionChildEvent.js.map